import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarginBottomIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M13.5 3.33203H6.5C5.09987 3.33203 4.3998 3.33203 3.86502 3.52883C3.39462 3.70193 3.01217 3.97814 2.77248 4.31788C2.5 4.70411 2.5 5.20971 2.5 6.22092V11.2765C2.5 12.2877 2.5 12.7933 2.77248 13.1795C3.01217 13.5193 3.39462 13.7955 3.86502 13.9686C4.3998 14.1654 5.09987 14.1654 6.5 14.1654H10H13.5C14.9001 14.1654 15.6002 14.1654 16.135 13.9686C16.6054 13.7955 16.9878 13.5193 17.2275 13.1795C17.5 12.7933 17.5 12.2877 17.5 11.2765V6.22092C17.5 5.20971 17.5 4.70411 17.2275 4.31788C16.9878 3.97814 16.6054 3.70193 16.135 3.52883C15.6002 3.33203 14.9001 3.33203 13.5 3.33203Z"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5827 17.5H9.99935H5.41602"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
